export default {
    getHTMLTextForReact: value => {
        return { __html: value };
    },
    /**
     * Fonction retournant le chemin d'appel de l'API en fonction de l'environnement.
     * Si la variable globale "prefixAPI" est définie, elle sera utilisée par rapport à l'environnement d'exécution.
     */
    getPrefixAPI: () => {
        let prefixAPI = "";
        const listPrefix = {
            "unit": "/pls/hkc_devlp1/",
            "fonc": "/pls/hkcf1/",
            "accp": "/pls/hkca1/",
            "prod": "/pls/hkcp1/",
            "diff": "/pls/hkc/"
        };
        if (window.prefixAPI) {
            prefixAPI = window.prefixAPI;
        }
        else if (process.env.NODE_ENV === 'development') {
            prefixAPI = listPrefix.diff;
        }
        else {
            switch (window.location.hostname) {
                case "u1.stat":
                    prefixAPI = listPrefix.unit;
                    break;
                case "f1.stat":
                    prefixAPI = listPrefix.fonc;
                    break;
                case "a1.stat":
                    prefixAPI = listPrefix.accp;
                    break;
                case "p1.stat":
                    prefixAPI = listPrefix.prod;
                    break;
                default:
                    prefixAPI = listPrefix.diff
            }
        }

        return prefixAPI;
    },
    parseQueryString: () => {
        var query = window.location.search.replace('?', '');
        var vars = query.split("&");
        var query_string = {};
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            // If first entry with this name
            if (typeof query_string[pair[0]] === "undefined") {
                query_string[pair[0]] = decodeURIComponent(pair[1]);
                // If second entry with this name
            } else if (typeof query_string[pair[0]] === "string") {
                var arr = [query_string[pair[0]], decodeURIComponent(pair[1])];
                query_string[pair[0]] = arr;
                // If third or later entry with this name
            } else {
                query_string[pair[0]].push(decodeURIComponent(pair[1]));
            }
        }
        return query_string;
    }
};